import { combine, createEffect, createEvent, createStore, merge } from 'effector';
import { replaceEmployee } from '../../api/replace-employee';
import { ReplaceEmployeeForm } from './types';
import { AssigneesReplaceByTypesPayload } from './types/assigneesReplaceByTypesRequest';
import {
  GetCountsByTypesPalyload,
  GetCountsByTypesResponse,
} from './types/countsByTypesRequest';

export const defaultReplaceEmployeeForm = {
  replaceableEmployee: null,
  appointedEmployee: null,
  types: [],
  withoutTypeCheckbox: false,
} as ReplaceEmployeeForm;

export const $isReplaceEmployee = createStore(false);
export const setReplaceEmployee = createEvent<boolean>();

export const getTypesForReplaceEmployee = createEvent<number>();

export const $typesForReplaceEmployee = createStore<GetCountsByTypesResponse>(
  {} as GetCountsByTypesResponse
);
export const $activeTypesIds = combine(
  $typesForReplaceEmployee,
  (typesForReplaceEmployee) =>
    typesForReplaceEmployee?.tickets?.types.map(({ id }) => String(id))
);
export const $ticketsCountByTypesIds = combine(
  $typesForReplaceEmployee,
  (typesForReplaceEmployee) =>
    (typesForReplaceEmployee.tickets?.types ?? []).reduce((acc, { id, count }) => {
      acc[id] = count;

      return acc;
    }, {} as { [key: string]: number })
);
export const $ticketsCountWithoutType = combine(
  $typesForReplaceEmployee,
  (typesForReplaceEmployee) => typesForReplaceEmployee?.tickets?.without_types ?? null
);

export const $replaceEmployeeForm = createStore<ReplaceEmployeeForm>(
  defaultReplaceEmployeeForm
);

export const fxGetCountsByTypesForReplaceAssignee = createEffect<
  GetCountsByTypesPalyload,
  GetCountsByTypesResponse,
  Error
>().use(replaceEmployee.getCountsByTypesForReplaceAssignee);

export const $assigneesReplaceByTypesData = createStore<ReplaceEmployeeForm>(
  defaultReplaceEmployeeForm
);
export const assigneesReplaceByTypes = createEvent<ReplaceEmployeeForm>();

export const fxAssigneesReplaceByTypes = createEffect<
  AssigneesReplaceByTypesPayload,
  void,
  Error
>().use(replaceEmployee.assigneesReplaceByTypes);

export const $isReplaceEmployeeLoading = createStore(false);

export const $error = createStore<Error | null>(null);
export const clearError = createEvent();

export const errorOccured = merge([
  fxGetCountsByTypesForReplaceAssignee.fail,
  fxAssigneesReplaceByTypes.fail,
]);
